import { render } from "./SpmDateDisplay.vue?vue&type=template&id=268bd30c&scoped=true"
import script from "./SpmDateDisplay.vue?vue&type=script&lang=ts"
export * from "./SpmDateDisplay.vue?vue&type=script&lang=ts"

import "./SpmDateDisplay.vue?vue&type=style&index=0&id=268bd30c&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-268bd30c"

export default script